import { render, staticRenderFns } from "./MoleculeSidebarRoutes.vue?vue&type=template&id=eed942f4&"
import script from "./MoleculeSidebarRoutes.vue?vue&type=script&lang=js&"
export * from "./MoleculeSidebarRoutes.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeSidebarRoutes.vue?vue&type=style&index=0&id=eed942f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsProjectAtomRoute: require('/app/components/atoms/project/AtomRoute.vue').default,AtomsProjectAtomLocationType: require('/app/components/atoms/project/AtomLocationType.vue').default})
